
/* JSON data
    type : "FeatureCollection"
    features: [
        {
            id: "", // Обязательное поле, по id можно искать точку
            type: "Feature", // Обязательное поле
            geometry: {
                type: "Point",
                coordinates: [широта, долгота] // Вычисляется по api какого то геокодера
            },
            properties: {
                iconCaption: "Заголовок метки",
                hasBalloon: false // скрытие подсказки
            }
        }
    ]
* */

if (geo_lat != undefined && geo_lon != undefined && name_company != undefined) {
    var data = {
        type: "FeatureCollection",
        features: [
            {
                id: "1",
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [geo_lat, geo_lon]
                },
                properties: {
                    iconCaption: name_company,
                    hasBalloon: false
                }
            }
        ]
    }
}




ymaps.ready(initMap)

function initMap() {

    let inputSearch = new ymaps.control.SearchControl({
        options: {
            visible: false
        }
    })

    let zoomControl = new ymaps.control.ZoomControl({
        options: {
            visible: true
        }
    })




    var myMap = new ymaps.Map("map", {
        // Координаты центра карты
        center: [geo_lat, geo_lon],
        controls: [inputSearch, zoomControl],
        // Масштаб карты (город)
        zoom: 10,

    },{suppressMapOpenBlock: true});

    let objectManager = new ymaps.ObjectManager({
        // Чтобы метки начали кластеризоваться, выставляем опцию.
        clusterize: true,
        // ObjectManager принимает те же опции, что и кластеризатор.
        gridSize: 32,
        clusterHasBalloon: false,
        clusterDisableClickZoom: true
    });


    objectManager.objects.options.set('preset', 'islands#greenDotIconWithCaption');
    objectManager.objects.options.set('iconColor', '#075055');
    objectManager.clusters.options.set('clusterPreset', 'islands#greenClusterIcons');
    objectManager.clusters.options.set('clusterIconColor', '#075055');

    myMap.behaviors.disable('scrollZoom')

    myMap.geoObjects.add(objectManager);

    if (data != undefined) {
        objectManager.add(data)
    }


    // myMap.geoObjects.add(new ymaps.Placemark([59.93, 30.31], {
    //     iconCaption: "Название филиала очень длинное, которое не влезет сюда",
    //     hasBalloon: false
    // },{
    //     preset: 'islands#greenDotIconWithCaption',
    //     iconColor: "#000000"
    // }))
}

$(function () {
    if (Object.keys(avg_okved).length > 0)
        new Chart($("#ring-place-money")[0], {
            type: "doughnut",
            data: {
                datasets: [{
                    data: [avg_okved.debt.my, avg_okved.expenditure.my, avg_okved.income.my], // Задолжность, Расход, Доход
                    backgroundColor: [
                        '#B7B7B7',
                        '#FFAEAA',
                        '#C1EFC7'
                    ],
                    borderColor: ["#9E9B98", "#E60C0C", "#57DD64"],
                    borderWidth: 1,
                    offset: 3,
                    hoverBackgroundColor: ['#B7B7B7', '#FFAEAA', '#C1EFC7'],
                    hoverBorderColor: ["#9E9B98", "#E60C0C", "#57DD64"]
                }]
            },
            options: {
                cutout: 95,
                radius: "100%",
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    tooltip: {
                        // intersect:false,
                        backgroundColor: "white",
                        titleColor: "black",
                        // xAlign: "center",
                        yAlign: "top",
                        titleAlign: 'center',
                        bodyColor: 'black',
                        bodyFont: {
                            family: "Montserrat",
                            size: 14,
                            weight: 600
                        },
                        callbacks: {
                            label: () => {
                                return ""
                            },
                            afterBody: (context) => {
                                return formatNumber(context[0].parsed)
                            }
                        }
                    }
                },
            },
            elements: {
                bar: {
                    barThickness: "100"
                }
            }
        })
    let dataMoney
    if (Object.keys(avg_okved).length > 0 && avg_okved.income.my != null && avg_okved.income.avg != null) {
        dataMoney = [avg_okved.income.my, avg_okved.income.avg].map(elem => Number(elem))
    } else {
        dataMoney = false;
    }
    let dataEployees
    if (Object.keys(avg_okved).length > 0 && avg_okved.employs.my != null && avg_okved.employs.avg != null) {
        dataEployees = [avg_okved.employs.my, avg_okved.employs.avg].map(elem => Number(elem))
    } else {
        dataEployees = false;
    }
    let width, height, gradient;


    // let anchor = $(document).width() > 576 ? "end" : "start"
    // let rotation = $(document).width() > 576 ? 0 : -90
    // let anchor2 = $(document).widht() > 576 ? "end" : "center"

    if (dataEployees != false && $("#count-employees")[0]) {
        new Chart($("#count-employees")[0], {
            type: "bar",
            data: {
                labels: ["Количество сотрудников компании", "Среднее значение"],
                datasets: [{
                    data: dataEployees,
                    backgroundColor: function (context) {
                        const chart = context.chart
                        const {ctx, chartArea} = chart
                        if (! chartArea)
                            return
                        if (dataEployees[0] > dataEployees[1]) {
                            return  [getGradient(ctx, chartArea, "rgb(191,237,198)"), "#A6A6A6"]
                        }
                        else {
                            return [getGradient(ctx, chartArea, "rgb(255,174,170)"), "#A6A6A6"]
                        }
                    },
                    hoverBackgroundColor: function (context) {
                        const chart = context.chart
                        const {ctx, chartArea} = chart
                        if (!chartArea)
                            return
                        if (dataEployees[0] > dataEployees[1]) {
                            return  [getGradient(ctx, chartArea, "rgb(191,237,198)"), "#A6A6A6"]
                        }
                        else {
                            return [getGradient(ctx, chartArea, "rgb(255,174,170)"), "#A6A6A6"]
                        }
                    }
                }]
            },
            options: {
                responsive: true,
                scales: {
                    x: {
                        display: false, // Убрать значения с горизонтальной оси
                        grid: {
                            display: false
                        },
                        beginAtZero: true
                    },
                    y: {
                        display: false, // Убрать значения с вертикальной оси
                        max: Math.max(...dataEployees) * 1.5,
                        grid: {
                            display: false
                        },
                        beginAtZero: true
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        // enabled: false,
                        // intersect:false,
                        backgroundColor: "white",
                        titleColor: "black",
                        // xAlign: "center",
                        yAlign: "bottom",
                        titleAlign: 'center',
                        bodyColor: 'black',
                        bodyFont: {
                            family: "Montserrat",
                            size: 14,
                            weight: 600
                        },
                        titleFont: {
                            family: "Montserrat",
                            size: 14,
                            weight: 600
                        },
                        callbacks: {
                            label: () => {
                                return ""
                            },
                        }
                    },
                    datalabels: {
                        labels: {
                            title: "black",
                            text: "qrqwrqwr"
                        },
                        anchor: "end",
                        align: "top",
                        // rotation: rotation,
                        textAlign: "center",
                        // align: "center",
                        color: '#606372', // Цвет текста
                        font: {
                            family: "Montserrat",
                            weight: 500,
                            size: 14
                        },
                        formatter: function(value, context) {
                            return value; // Формат текста (в данном случае, выводим значение)
                        },
                    }
                }
            },
            plugins: [ChartDataLabels]
        })
    }

    if (dataMoney != false && $("#profit-company")[0]) {
        new Chart($("#profit-company")[0], {
            type: "bar",
            data: {
                labels: ["Выручка компании", "Средний показатель"],
                datasets: [{
                    data: dataMoney,
                    backgroundColor: function (context) {
                        const chart = context.chart
                        const {ctx, chartArea} = chart
                        if (! chartArea)
                            return
                        if (dataMoney[0] > dataMoney[1]) {
                            return  [getGradient(ctx, chartArea, "rgb(191,237,198)"), "#A6A6A6"]
                        }
                        else {
                            return [getGradient(ctx, chartArea, "rgb(255,174,170)"), "#A6A6A6"]
                        }
                    },
                    hoverBackgroundColor: function (context) {
                        const chart = context.chart
                        const {ctx, chartArea} = chart
                        if (!chartArea)
                            return
                        if (dataMoney[0] > dataMoney[1]) {
                            return [getGradient(ctx, chartArea, "rgb(191,237,198)"), "#A6A6A6"]
                        } else {
                            return [getGradient(ctx, chartArea, "rgb(255,174,170)"), "#A6A6A6"]
                        }
                    }
                }]
            },
            options: {
                responsive: true,
                scales: {
                    x: {
                        display: false, // Убрать значения с горизонтальной оси
                        grid: {
                            display: false
                        },
                        beginAtZero: true
                    },
                    y: {
                        display: false, // Убрать значения с вертикальной оси
                        max: Math.max(...dataMoney) * 1.5,
                        grid: {
                            display: false
                        },
                        beginAtZero: true
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        // enabled: false,
                        // intersect:false,
                        backgroundColor: "white",
                        titleColor: "black",
                        // xAlign: "center",
                        yAlign: "bottom",
                        titleAlign: 'center',
                        bodyColor: 'black',
                        bodyFont: {
                            family: "Montserrat",
                            size: 14,
                            weight: 600
                        },
                        titleFont: {
                            family: "Montserrat",
                            size: 14,
                            weight: 600
                        },
                        callbacks: {
                            label: () => {
                                return ""
                            },
                        }
                    },
                    datalabels: {
                        anchor: "end",
                        align: "top",
                        // rotation: rotation,
                        clamp: true,
                        textAlign: "center",
                        // align: "center",
                        color: '#606372', // Цвет текста
                        font: {
                            family: "Montserrat",
                            weight: 500,
                            size: 14
                        },
                        formatter: function(value, context) {
                            return formatNumber(value); // Формат текста (в данном случае, выводим значение)
                        },
                    }
                }
            },
            plugins: [ChartDataLabels]
        })
    }



    if (Object.keys(fin_coef_assets).length > 0) {
        new Chart($("#rent-capital")[0], {
            type: "line",
            data: {
                labels: fin_coef_assets.labels,
                datasets: [{
                    label: "Среднее значение по отрасли",
                    data: fin_coef_assets.norma, // первый график, ср.знач по отрасли
                    borderColor: "#4033FF",
                    pointBackgroundColor: "#4033FF",
                    hoverPointBackgroundColor: "#4033FF"
                }, {
                    label: "Рентабельность капитала компании",
                    data: fin_coef_assets.znach, // второй график, рентабельность капитала компании
                    borderColor: context => getColorLine(context),
                    pointBackgroundColor: context => getColorLine(context),
                    hoverPointBackgroundColor: context => getColorLine(context),
                }, {
                    label: "Верхняя граница среднего значения",
                    data: fin_coef_assets.norma_up, // верхняя граница среднего значения
                    fill: {
                        target: 2,
                        above: "#D1D1D1",
                        below: "#D1D1D1"
                    },
                    borderWidth: 0,
                    pointRadius: 0,
                    hoverRadius: 0
                }, {
                    label: "Нижняя граница среднего значения",
                    data: fin_coef_assets.norma_down, // нижняя граница среднего значения
                    fill: {
                        target: 2,
                        above: "#D1D1D1",
                        below: "#D1D1D1"
                    },
                    borderWidth: 0,
                    pointRadius: 0,
                    hoverRadius: 0

                }],
            },
            options: {
                responsive: true,
                scales: {
                    x: {
                        grid: {
                            display: true
                        }
                    },
                    y: {
                        display: false,
                        grid: {
                            display: false
                        },
                    }
                },
                elements: {
                    point: {
                        radius: 6,
                        hoverRadius: 6
                    }
                },
                interaction: {
                    intersect: false
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        displayColors: false,
                        backgroundColor: "white",
                        titleColor: "black",
                        xAlign: "center",
                        yAlign: "top",
                        titleAlign: 'center',
                        bodyColor: 'black',
                        bodyFont: {
                            family: "Montserrat",
                            size: 14,
                            weight: 600
                        },
                        callbacks: {
                            title: function (context) {
                                return ""
                            },
                        }
                    }
                }
            }
        })
    }


    if (Object.keys(fin_coef_sale).length > 0) {
        new Chart($("#rent-sales")[0], {
            type: "line",
            data: {
                labels: fin_coef_sale.labels,
                datasets: [{
                    label: "Среднее значение по отрасли",
                    data: fin_coef_sale.norma, // первый график, ср.знач по отрасли
                    borderColor: "#4033FF",
                    pointBackgroundColor: "#4033FF",
                    hoverPointBackgroundColor: "#4033FF"
                }, {
                    label: "Рентабельность продаж компании",
                    data: fin_coef_sale.znach, // второй график, рентабельность продаж компании
                    borderColor: context => getColorLine(context),
                    pointBackgroundColor: context => getColorLine(context),
                    hoverPointBackgroundColor: context => getColorLine(context),
                }, {
                    label: "Верхняя граница среднего значения",
                    data: fin_coef_sale.norma_up, // верхняя граница среднего значения
                    fill: {
                        target: 2,
                        above: "#D1D1D1",
                        below: "#D1D1D1"
                    },
                    borderWidth: 0,
                    pointRadius: 0,
                    hoverRadius: 0
                }, {
                    label: "Нижняя граница среднего значения",
                    data: fin_coef_sale.norma_down, // нижняя граница среднего значения
                    fill: {
                        target: 2,
                        above: "#D1D1D1",
                        below: "#D1D1D1"
                    },
                    borderWidth: 0,
                    pointRadius: 0,
                    hoverRadius: 0

                }],
            },
            options: {
                responsive: true,
                scales: {
                    x: {
                        grid: {
                            display: true
                        }
                    },
                    y: {
                        display: false,
                        grid: {
                            display: false
                        },
                    }
                },
                elements: {
                    point: {
                        radius: 6,
                        hoverRadius: 6
                    }
                },
                interaction: {
                    // mode: 'nearest',
                    // axis: 'x',
                    intersect: false
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        displayColors: false,
                        backgroundColor: "white",
                        titleColor: "black",
                        xAlign: "center",
                        yAlign: "top",
                        titleAlign: 'center',
                        bodyColor: 'black',
                        bodyFont: {
                            family: "Montserrat",
                            size: 14,
                            weight: 600
                        },
                        callbacks: {
                            title: function (context) {
                                return ""
                            },
                        }
                    }
                }
            }
        })
    }

    function getColorLine(context){
        const dataset2 = context.chart.data.datasets[1];
        const lastValue1 = context.chart.data.datasets[0].data[context.dataset.data.length - 1];
        const lastValue2 = dataset2.data[dataset2.data.length - 1];
        return lastValue1 > lastValue2 ? '#FFAEAA' : '#C1EFC7';
    }

    function getGradient(ctx, chartArea, color) {
        gradient = null
        width = null
        height = null
        const chartWidth = chartArea.right - chartArea.left;
        const chartHeight = chartArea.bottom - chartArea.top;
        if (!gradient || width !== chartWidth || height !== chartHeight) {
            // Create the gradient because this is either the first render
            // or the size of the chart has changed
            width = chartWidth;
            height = chartHeight;
            gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
            gradient.addColorStop(0, "#A6A6A6");
            gradient.addColorStop(0.7, color);

        }

        return gradient;
    }
})

$(function () {
    if (!avg_okved.income.avg && !avg_okved.income.my)
        return

    let maxValue = Math.max(avg_okved.income.avg, avg_okved.income.my)

    let normalizationFactor = getNormalizationFactor(maxValue)

    const avgOkvedIncomeNormalized = avg_okved.income.avg / normalizationFactor
    const myOkvedIncomeNormalized = avg_okved.income.my / normalizationFactor

    const scalingFactor = 160 / Math.max(avgOkvedIncomeNormalized, myOkvedIncomeNormalized)

    $("#graph-column-1").height(myOkvedIncomeNormalized * scalingFactor)
    $("#graph-column-2").height(avgOkvedIncomeNormalized * scalingFactor)
    $("#graph-column-1").find(".text-graph-rotate").text(formatNumber(avg_okved.income.my))
    $("#graph-column-2").find(".text-graph-rotate").text(formatNumber(avg_okved.income.avg))
    $("#graph-column-2").css("background", "#A6A6A6")
    if (Number(avg_okved.income.my) > Number(avg_okved.income.avg)) {
        $("#graph-column-1").css("background", "linear-gradient(180deg, rgba(191,237,198,1) 0%, rgba(166,166,166,1) 79%)")
    }
    else {
        $("#graph-column-1").css("background", "linear-gradient(180deg, rgba(255,174,170,1) 0%, rgba(166,166,166,1) 79%)")
    }

})

$(function () {
    if (!avg_okved.employs.avg && !avg_okved.employs.my)
        return

    let maxValue = Math.max(avg_okved.employs.avg, avg_okved.employs.my)

    let normalizationFactor = getNormalizationFactor(maxValue)

    const avgOkvedEmploysNormalized = avg_okved.employs.avg / normalizationFactor
    const myOkvedEmploysNormalized = avg_okved.employs.my / normalizationFactor

    const scalingFactor = 160 / Math.max(avgOkvedEmploysNormalized, myOkvedEmploysNormalized)

    $("#graph-column-3").height(myOkvedEmploysNormalized * scalingFactor)
    $("#graph-column-4").height(avgOkvedEmploysNormalized * scalingFactor)
    $("#graph-column-3").find(".text-graph-rotate").text(avg_okved.employs.my)
    $("#graph-column-4").find(".text-graph-rotate").text(avg_okved.employs.avg)

    if (Number(avg_okved.employs.my) > Number(avg_okved.employs.avg)) {
        $("#graph-column-3").css("background", "linear-gradient(180deg, rgba(191,237,198,1) 0%, rgba(166,166,166,1) 79%)")
    }
    else {
        $("#graph-column-3").css("background", "linear-gradient(180deg, rgba(255,174,170,1) 0%, rgba(166,166,166,1) 79%)")
    }
})


function getNormalizationFactor (value) {
    if (value === 0) return 1;

    let orderOfMagnitude = Math.floor((Math.log10(value)))
    return Math.pow(10, orderOfMagnitude)
}
function formatNumber (okved) {
    if (okved / 1000000000000 >= 1)
        return `${(okved / 1000000000000).toFixed(2)} трн. ₽`
    else if (okved / 1000000000 >= 1)
        return `${(okved / 1000000000).toFixed(2)} млрд. ₽`
    else if (okved / 1000000 >= 1)
        return `${(okved / 1000000).toFixed(2)} млн. ₽`
    else
        return `${okved.toLocaleString("ru-RU")} тыс. ₽`
}

